var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "formCompany", on: { change: _vm.submitForm } },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "b-row",
            { staticClass: "d-flex align-items-center" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "10" } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: "Lead Source",
                      vid: "Lead Source",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Lead Source*",
                                  "label-for": "h-First",
                                },
                              },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    rules: "required",
                                    options: _vm.sourceDDL,
                                  },
                                  model: {
                                    value: _vm.company.profile.source,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.company.profile,
                                        "source",
                                        $$v
                                      )
                                    },
                                    expression: "company.profile.source",
                                  },
                                }),
                                errors.length
                                  ? _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "d-flex align-items-center",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.showModal("Source")
                        },
                      },
                    },
                    [_vm._v(" Add Source ")]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Company Name*",
                        "label-for": "h-company",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          name: "Company Name",
                          vid: "Company Name",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "h-full",
                                    placeholder: "Company Name",
                                  },
                                  model: {
                                    value: _vm.company.otherName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.company, "otherName", $$v)
                                    },
                                    expression: "company.otherName",
                                  },
                                }),
                                errors.length
                                  ? _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.isCollapseComp = !_vm.isCollapseComp
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            this.isCollapseComp ? "See More" : "See Less"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              !_vm.isCollapseComp
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "Sales Person",
                              vid: "Sales Person",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Sales Person",
                                            "label-for": "h-First",
                                          },
                                        },
                                        [
                                          _c("b-form-select", {
                                            attrs: {
                                              options: _vm.optionsSalesPerson,
                                            },
                                            model: {
                                              value: _vm.company.salesPersonId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.company,
                                                  "salesPersonId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "company.salesPersonId",
                                            },
                                          }),
                                          errors.length
                                            ? _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3213102198
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "email_regex",
                              name: "Email",
                              vid: "Email",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Email",
                                            "label-for": "d-email",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "d-email",
                                              type: "email",
                                              placeholder:
                                                "Enter your email (e.g., example@domain.com)",
                                            },
                                            model: {
                                              value: _vm.company.email,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.company,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression: "company.email",
                                            },
                                          }),
                                          errors.length
                                            ? _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3354129824
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Address Line 1",
                                "label-for": "h-Address",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "h-Address",
                                  placeholder: "Address",
                                },
                                model: {
                                  value: _vm.company.addressLine1,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.company, "addressLine1", $$v)
                                  },
                                  expression: "company.addressLine1",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Address Line 2",
                                "label-for": "h-Street",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "h-Street",
                                  placeholder: "Street Name",
                                },
                                model: {
                                  value: _vm.company.addressLine2,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.company, "addressLine2", $$v)
                                  },
                                  expression: "company.addressLine2",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "10" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "City", "label-for": "h-City" } },
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.cityOptions },
                                model: {
                                  value: _vm.company.profile.city,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.company.profile, "city", $$v)
                                  },
                                  expression: "company.profile.city",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex align-items-center",
                          attrs: { cols: "12", sm: "2" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "w-100",
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.showModal("City")
                                },
                              },
                            },
                            [_vm._v(" Add City ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Telephone",
                                "label-for": "h-Telephone",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "h-Telephone",
                                  placeholder: "Telephone",
                                  type: "number",
                                  onkeydown:
                                    "javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'",
                                },
                                model: {
                                  value: _vm.company.tel,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.company, "tel", $$v)
                                  },
                                  expression: "company.tel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Category",
                                "label-for": "h-SpecialInstructions",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "h-SpecialInstructions",
                                  placeholder: "Category",
                                },
                                model: {
                                  value: _vm.company.fieldInstruction,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.company,
                                      "fieldInstruction",
                                      $$v
                                    )
                                  },
                                  expression: "company.fieldInstruction",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Website",
                                "label-for": "h-Website",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "h-Website",
                                  placeholder: "Website",
                                },
                                model: {
                                  value: _vm.company.website,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.company, "website", $$v)
                                  },
                                  expression: "company.website",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "VAT Number",
                                "label-for": "h-Number",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "h-Number",
                                  placeholder: "VAT Number",
                                },
                                model: {
                                  value: _vm.company.vatNumber,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.company, "vatNumber", $$v)
                                  },
                                  expression: "company.vatNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Company BRN",
                                "label-for": "h-Number",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "h-Number",
                                  placeholder: "Company BRN",
                                },
                                model: {
                                  value: _vm.company.brn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.company, "brn", $$v)
                                  },
                                  expression: "company.brn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "10" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Products Interested in",
                                "label-for": "h-title",
                              },
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  multiple: "",
                                  placeholder: "Add Products Interested in",
                                  label: "itemTitle",
                                  options: _vm.productInterestOptions,
                                },
                                model: {
                                  value:
                                    _vm.company.profile.productsInterestedIn,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.company.profile,
                                      "productsInterestedIn",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "company.profile.productsInterestedIn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex align-items-center",
                          attrs: { cols: "12", sm: "2" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "w-100",
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.showModal("ProductInterest")
                                },
                              },
                            },
                            [_vm._v(" Add Product Interest ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Marketing Segment",
                                "label-for": "h-title",
                              },
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  multiple: "",
                                  placeholder: "Add Products Interested in",
                                  label: "itemTitle",
                                  options: _vm.segmentOptions,
                                },
                                model: {
                                  value: _vm.company.profile.marketingSegments,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.company.profile,
                                      "marketingSegments",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "company.profile.marketingSegments",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Percentage",
                                "label-for": "d-percentage",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "input-group" },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "d-percentage",
                                      type: "number",
                                      placeholder: "Percentage",
                                      min: "0",
                                      max: "100",
                                    },
                                    model: {
                                      value: _vm.company.percentage,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.company,
                                          "percentage",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "company.percentage",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "input-group-append" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "input-group-text" },
                                        [_vm._v("%")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          !_vm.isCollapseComp
            ? _c("CustomFieldsDetails", {
                attrs: {
                  AdditionalFields: _vm.company.additionalFields,
                  ModuleReference: "LeadClient",
                },
                on: { onchange: _vm.additionalFieldChanges },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: _vm.modalId, title: _vm.modalTitle, "hide-footer": "" },
        },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.addItem($event)
                },
              },
            },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Add " + _vm.modalTitle,
                    "label-for": "input-new-item",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "input-new-item",
                      required: "",
                      placeholder: "Enter new item",
                    },
                    model: {
                      value: _vm.newItem,
                      callback: function ($$v) {
                        _vm.newItem = $$v
                      },
                      expression: "newItem",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-button",
                { attrs: { type: "submit", variant: "primary" } },
                [_vm._v("Add")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "p-1",
              staticStyle: { "max-height": "500px", "overflow-y": "auto" },
            },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  items: _vm.modalOptions,
                  responsive: "",
                  fields: _vm.fields,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(name)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.modalType === "PRODUCTINTEREST"
                                ? data.item.itemTitle
                                : data.item.text
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(actions)",
                    fn: function (data) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteItem(data.item.value)
                              },
                            },
                          },
                          [_vm._v("Delete")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }